import React, { useRef } from "react";
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import SideMenu from "components/Sidebar/SideMenu";

const Layout = (props) => {
  const mainPanel = useRef();
  return (
    <div className="wrapper">
      <div className="main-panel" ref={mainPanel}>
        <Header />
        <SideMenu />
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
